import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { useAppData } from '../../core/context/AppDataContext';
import { ReportType } from '../../core/api/clients';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';

import DispatchEventHome from './DispatchEventHome';
import DispatchEventFormNew from './DispatchEventFormNew';
import DispatchEventFormLayout from './DispatchEventFormLayout';
import DispatchEventFormEdit from './DispatchEventFormEdit';
import DispatchEventFormView from './DispatchEventFormView';
import useTitle from '../../core/api/hooks/common/useTitle';

function DispatchEventContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.DispatchEventReport);

    if (form !== undefined) {
      const { isContributor, isAdministrator, isReader, isApprover } = form;

      const canEdit = (isContributor || isApprover || isAdministrator);
      const canView = (isReader || canEdit);

      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<DispatchEventFormLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={canEdit ?? false}>
                    <DispatchEventFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth
                    isAuthorized={canView ?? false}
                  >
                    <DispatchEventFormView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              path="new"
              element={(
                <RequireAuth isAuthorized={form.isContributor ?? false}>
                  <DispatchEventFormNew />
                </RequireAuth>
              )}
            />
            <Route
              index
              element={(
                <DispatchEventHome />
              )}
            />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return (
      <span>Not Authorized</span>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default DispatchEventContainer;
